import React, { Fragment } from "react";
import "./productcategory.scss";
require("dotenv").config();

const ProductCategory = ({ category }) => {
  return (
    <Fragment>
      <div className="product-category-container mr-1">
        <div className="product-category-image-container ">
          <a
            href={`${
              process.env.REACT_APP_STORE_DOMAIN
            }/${category?.country_name_en?.toLowerCase()}-en/all-categories`}
            style={{ textDecoration: "none", color: "unset" }}
          >
            <img src={category.image} alt="category" />
          </a>
        </div>
      </div>
    </Fragment>
  );
};

export default ProductCategory;
